export default {
  TABLE_MAX_WIDTH: 1023,
  MOBILE_MAX_WIDTH: 479,
  SIDEBAR_WIDTH: 127,
  FOOTER_HEIGHT: 120,
}
